export default "__VITE_ASSET__D8lObcH0__"